import React, { useEffect, useState, useRef } from 'react';

import '../assets/css/CollectionListRow.css'

const CollectionMaininfoPageCell = (props) => {
    const [overflow, setOverflow] = useState('begin')
    const [toggleExpand, setToggleExpand] = useState(false)
    const [divHeight, setDivHeight] = useState(null)
    const toggleRef = useRef(null);

    useEffect(()=>{
        checkOverflow()
    }, [])

    const checkOverflow=()=>{
        if(toggleRef.current.clientHeight < toggleRef.current.scrollHeight){
            setOverflow(true)
            setDivHeight(toggleRef.current.scrollHeight)
        }else{
            setOverflow(false)
        }
    }

    const toggleChange=()=>{
        setToggleExpand(!toggleExpand)
    }

    const getStyle = () => {
        let output = null
        let expandStyle={
            height:divHeight
        }
        let shrinkStyle = {
            height:'fit-content',
            overflow:null
        }
        if(overflow === true){
            if(toggleExpand){
                output = expandStyle
            }
        }else if(overflow === false){
            output = shrinkStyle
        }
        return output
    }

    return(
        <div>
            <div className="ExpandTextArea" ref={toggleRef} style={getStyle()}>
                {props.children}
            </div>
            {overflow?
                <div className={"ShowMoreButtom"} onClick={toggleChange}>
                {toggleExpand?  
                    <><span style={{color:'#bede07'}}>{'↑'}</span>收合段落</>
                    :
                    <><span style={{color:'#bede07'}}>{'↓'}</span>完整段落</>
                }
                </div>  
            :null}
        </div>
    )
}

export default CollectionMaininfoPageCell